import React, { Component } from 'react'
import { DropdownButton, MenuItem } from 'react-bootstrap'

export default class SelectButton extends Component {
  render(){
    const { id, title, onSelectedItem } = this.props
    const options = this.props.options ? this.props.options : this.props.children

    if (options.length > 0 && options[0].name) {
      return(
        <DropdownButton
          title={title} key={id} id='dropdown-basic' onSelect={(index)=>{ onSelectedItem(options[index]) }}
        >
          {options.map((item, index) =>
            <MenuItem eventKey={index} key={index}>{item.name}</MenuItem>
          )}
        </DropdownButton>
      )
    }

    return(
      <DropdownButton title={title} key={id} id='dropdown-basic' onSelect={onSelectedItem} >
        {options.map((item, index) =>
          <MenuItem eventKey={item} key={index}>{item}</MenuItem>
        )}
      </DropdownButton>
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/FormSearch/selectButton.js